module.exports = __webpack_public_path__ + "static/media/lab-white.98081644.svg";